import { type ApolloError } from "@apollo/client";
import { useDispatch } from "react-redux";

import type { ReduxDispatch } from "../../redux/redux-utils.ts";
import { createErrorHandler, type ErrorHandlerProps } from "../errors.ts";

/**
 * To be used after of an auto-generated hooks from a .graphql files.
 * It will automatically log the error and show an alert.
 * In case you are not in a Functional Component, @see query.ts
 */
export const useError = async (error?: ApolloError) => {
  const errorHandler = useErrorHandler();
  if (error) return errorHandler(error);
  return;
};

export const useErrorHandler = (
  options: Partial<ErrorHandlerProps> = {},
): ((error: ApolloError) => Promise<unknown>) => {
  const dispatch = useDispatch<ReduxDispatch>();

  return createErrorHandler(dispatch, {
    showAlert: true,
    throwError: false,
    ...options,
  });
};
